import { API, type PimFields } from "@thenounproject/lingo-core";
import { createAsyncAction } from "@actions/actionCreators";
import { toApiFields } from "@features/products/productTypeFields";

type Args = {
  spaceId: number;
  productTypeUuid: string;
  fields: PimFields;
  marketUuid?: string;
  status?: string;
};

const [useCreateProduct, createProduct] = createAsyncAction(
  "products/create",
  async ({ spaceId, productTypeUuid, fields, marketUuid, status }: Args) => {
    const res = await API.call<{ product: string }>({
      endpoint: `spaces/${spaceId}/products`,
      method: "POST",
      data: {
        product_type_uuid: productTypeUuid,
        fields: toApiFields(fields),
        market_uuid: marketUuid,
        status,
      },
    });
    return { ...res, result: res.result.product };
  }
);

export default useCreateProduct;
export { createProduct };
